module.exports = __webpack_public_path__ + "media/styles/images/png/circle-left-arrow-teal-on-white-2db01230f9c473666f3195ee11d07f3d.png";